var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralStatsArrowImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 25.872H8.79198C8.19598 25.872 7.71198 26.3502 7.71198 26.9304V34.2765H12.412V26.9304C12.412 26.3463 11.928 25.872 11.332 25.872Z",
    fill: "#DBD6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 34.2765H18V23.324C18 22.7399 17.516 22.2656 16.92 22.2656H14.38C13.788 22.2656 13.3 22.7438 13.3 23.324C13.3 26.9735 13.3 30.623 13.3 34.2765Z",
    fill: "#7C67F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.888 34.2765H23.584V18.377C23.584 17.981 23.256 17.6596 22.856 17.6596H19.616C19.216 17.6596 18.888 17.981 18.888 18.377C18.888 23.6768 18.888 28.9767 18.888 34.2765Z",
    fill: "#AB9DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.476 34.2765H29.172V13.2143C29.172 12.9752 29.372 12.7792 29.616 12.7792H32.288L26.824 4.92352L21.36 12.7792H24.028C24.276 12.7792 24.476 12.9752 24.476 13.2143C24.476 20.235 24.476 27.2558 24.476 34.2765Z",
    fill: "#3623AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralStatsArrowImg);
export default __webpack_public_path__ + "static/media/general_stats_arrow_img.f50ea7d7.svg";
export { ForwardRef as ReactComponent };